import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade createNewModal",
  id: "AddAdressePostaleModal",
  tabindex: "-1",
  ref: "addAdressePostaleModalRef",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content p-15 p-md-40" }
const _hoisted_4 = { class: "modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25" }
const _hoisted_5 = { class: "modal-title fw-bold text-black" }
const _hoisted_6 = { class: "modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = {
  class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16",
  type: "submit"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.title), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Form, {
            ref: "AdressePostaleForm",
            onSubmit: _ctx.addAdressePostale,
            "validation-schema": _ctx.adressePostaleSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _cache[1] || (_cache[1] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Adresse Postale "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "adresse_postale",
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Entrer une adresse"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "adresse_postale",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("button", _hoisted_10, _toDisplayString(_ctx.btntext), 1)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn-close shadow-none",
          "data-bs-dismiss": "modal",
          "aria-label": "Close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.resetValue()))
        })
      ])
    ])
  ], 512))
}